<template>
  <div>
    <b-row>

      <b-col md="12" class="d-flex align-items-center justify-content-between mb-1">
        <span class="text-muted" style="font-size:0.78rem;">Los campos con * son obligatorios</span>
        <b-link v-if="item && viewEdit"
                href="javascript:void(0);"
                class="small"
                @click="openFullEdit()">
          <b-icon icon="box-arrow-up-right" class="mr-1"></b-icon>
          Ver ficha completa
        </b-link>
      </b-col>

      <b-col md="12">
        <b-form-group label="Nombre *" label-size="sm">
          <b-form-input v-model="form.name"
                        size="sm"
                        placeholder="Nombre"
                        ref="inputName"
                        @keyup.enter.native="save()"
                        :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group label="Condición IVA" label-size="sm">
          <b-form-select v-model="form.iva_conditions_id" :options="options.ivaConditions" size="sm" :disabled="loading">
            <template #first>
              <b-form-select-option :value="0">— Sin condición —</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="12" class="d-flex justify-content-end mt-1">
        <b-button variant="outline-secondary" size="sm" class="mr-2" @click="$emit('cancel')" :disabled="loading">
          Cancelar
        </b-button>
        <b-button variant="primary" size="sm" @click="save()" :disabled="loading || !form.name.trim()">
          <b-icon icon="check" class="mr-1"></b-icon>
          Guardar
        </b-button>
      </b-col>

    </b-row>
  </div>
</template>
<script>
  import serviceAPI from '../services'

  export default {
    props: {
      item: { type: Object, default: null },
      viewEdit: { type: String, default: '' },
      viewEditParamID: { type: String, default: '' },
    },
    data() {
      return {
        form: { name: '', iva_conditions_id: 0, accounting_accounts_id: 0 },
        loading: false,
        options: { ivaConditions: [] },
      }
    },
    watch: {
      item: {
        immediate: true,
        handler(val) {
          if (val) {
            this.loadForEdit(val.id)
          } else {
            this.form = { name: '', iva_conditions_id: 0, accounting_accounts_id: 0 }
          }
        },
      },
    },
    mounted() {
      this.loadIvaConditions()
      this.$nextTick(() => { if (this.$refs.inputName) this.$refs.inputName.focus() })
    },
    methods: {
      loadIvaConditions() {
        serviceAPI.obtenerCondicionesIVA().then((r) => {
          this.options.ivaConditions = r.data.map((x) => ({ value: x.id, text: x.name }))
        })
      },
      loadForEdit(id) {
        this.loading = true
        serviceAPI.obtenerConcepto(id)
          .then((r) => {
            this.form = Object.assign({ name: '', iva_conditions_id: 0, accounting_accounts_id: 0 }, r.data)
            this.form.name = this.form.name || ''
            this.form.iva_conditions_id = this.form.iva_conditions_id || 0
            this.form.accounting_accounts_id = this.form.accounting_accounts_id || 0
          })
          .finally(() => { this.loading = false })
      },
      openFullEdit() {
        var params = {}
        params[this.viewEditParamID] = this.item.id
        var route = this.$router.resolve({ name: this.viewEdit, params: params })
        window.open(route.href, '_blank')
      },
      save() {
        if (!this.form.name.trim()) return
        this.loading = true
        var isEdit = this.item && this.item.id
        var data = Object.assign({}, this.form, {
          name: this.form.name.trim(),
          iva_conditions_id: this.form.iva_conditions_id,
          accounting_accounts_id: this.form.accounting_accounts_id,
        })
        var call = isEdit
          ? serviceAPI.editarConcepto(Object.assign({}, data, { id: this.item.id }))
          : serviceAPI.agregarConcepto(data)
        call
          .then((r) => {
            this.$awn.success(isEdit ? 'Concepto actualizado' : 'Concepto creado')
            this.$emit('saved', r.data)
          })
          .catch(() => { this.$awn.alert('Error al guardar') })
          .finally(() => { this.loading = false })
      },
    },
  }
</script>
